import React from 'react';
import './style.css';

const LoadingWrapper = ({
  children = null,
  loading = false,
  principal = 'Procesando',
  secundario = '',
  height = '100%',
} = {}) => {
  if (!loading) {
    return children;
  }

  return (
    <React.Fragment>
      <div className="container-fluid" style={{ height }}>
        <div className="row justify-content-center h-100">
          <div className="col-12 text-center align-self-center">
            <h3 style={{ fontSize: '40px' }}>{principal}</h3>
            <div className="loader">Loading...</div>
            <h5>{secundario}</h5>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default LoadingWrapper;
